const manualModalOpen = () => {
  const sizeGuideModal = document.querySelector('[data-size-guide]');
  const sizeGuideBtns = document.querySelectorAll('[data-size-guide-trigger]');

  if (sizeGuideModal) {
    sizeGuideBtns.forEach(sizeGuideBtn => {
      sizeGuideBtn.addEventListener('click', () => {
        sizeGuideModal.classList.add('visible');
        // const sizeGuideCloseBtn = document.querySelector('.size-guide-modal-close');
      });
    });
  }
};

export default manualModalOpen;
